// extracted by mini-css-extract-plugin
module.exports = {"rotation":"AziendaHubTemplate_rotation__29gkI"};